import { render, staticRenderFns } from "./WikiCollection.vue?vue&type=template&id=79b9e52c&"
import script from "./WikiCollection.vue?vue&type=script&lang=js&"
export * from "./WikiCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports